import React, { useEffect, useState } from "react";
import { getStatusColor, reduceLongName } from "../../../../ReusableFunctions/reusableFunctions";
import FilterRequest from "../FilterRequest/FilterRequest";
import { useLocation, useNavigate } from "react-router-dom";
import TableView from "../../../../ReusableComponents/TableView/TableView";
import search from "../../../../assets/search.svg";
import { PDRL_SUCCESS_ENGI_ROUTES, ROUTES } from "../../../../routes";
import ChipInput from "../../../../ReusableComponents/ChipInput";
import { ChipInputOptions } from "../../MyRequests";
import DatePickerField from "../../../../ReusableComponents/DatePickerField";
import SelectComponent from "../../../../ReusableComponents/SelectComponent";
import { getLocations } from "../../../../apis/locations";
import Popup from "../../../../ReusableFunctions/Popup";
import DatePicker from "react-datepicker";
import calender from "../../../../assets/blueCalendar.svg";
import ClearFilterButton from "../../../../ReusableComponents/TableView/ClearFilterButton";
import Tippy from "@tippyjs/react";


const getCurrentScreenSize = () => {
  const width = window.innerWidth;
  if (width >= 1860) {
    return "x-large";
  } else if (width < 1860 && width > 1620) {
    return "large";
  } else if (width <= 1620 && width > 1400) {
    return "medium";
  } else if (width > 1200 && width <= 1400) {
    return "small";
  }
};

const RequestTable = ({
  filters,
  pageNumber,
  requests,
  statusType,
  onFilterChange,
  loading,
  setLoading,
  dateTime,
  currentPage,
  totalCount,
  onCurrentPageChange,
  pageSize,
  isFromUserDetails,
  onSearch,
  tabelContainerHeight,
  hidePagination,
  isAdminRoute,
  onStatusFilterChanged,
  activeTab,
  onChangeTab
}) => {
  const nevigate = useNavigate();
  const { state } = useLocation();
  const [openFilter, setOpenFilter] = useState(false);
  const [currentWidth, setcurrentWidth] = useState(getCurrentScreenSize());
  const [localRequest, setLocalRequests] = useState(requests);
  const [locations, setLocations] = useState([]);
  const [screenWidth, setScreenWidth] = useState(1366);
  const [openDatePicker, setOpenDatePicker] = useState({
    fromDate: false,
    toDate: false,
  });

  useEffect(() => {
    setLocalRequests(requests);
  }, [requests]);

  useEffect(() => {
    const screenWidth = window.innerWidth;
    getLocationFunc();
    setScreenWidth(screenWidth);
    const handleResize = () => {
      setcurrentWidth(getCurrentScreenSize());
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.addEventListener("resize", handleResize);
    };
  }, []);

  const getLocationFunc = async () => {
    try {
      const locations = await getLocations();
      setLocations(locations);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      Popup.alert("Error", err, "ERROR");
    }
  };

  const clearFilters = () => {
    onFilterChange(filters, { fromDate: undefined, toDate: undefined });
  };

  useEffect(() => {
    clearFilters();
  }, [activeTab]);

  const selectedLocation = locations?.find(
    (location) => location?.id === filters?.locations[0]
  );

  return (
    <>
      <div
        style={{
          fontWeight: 600,
          display: "flex",
          alignItems: "flex-end",
          width: "100%",
          justifyContent: "space-between",
          gap: "10px",
          padding: "0px 0px 0px",
          borderBottom: "1px solid #BFC8D9"
        }}
      >
        <div className="request-table-header-title">
          <div className={`request-table-header-title-div text-center border-b-2 pb-1 hover:cursor-pointer
            ${activeTab === "ALL" ? "border-black" : "border-transparent"}`}
            onClick={() => onChangeTab("ALL")}
          >
            All Requests
          </div>
          <div className={`request-table-header-title-div text-center border-b-2 pb-1 hover:cursor-pointer
            ${activeTab === "BES" ? "border-black" : "border-transparent"}`}
            onClick={() => onChangeTab("BES")}
          >
            Lead Orders
          </div>
        </div>
        <div className="filters_section_wrapper pb-1">
          <div>
            <ClearFilterButton
              isVisible={dateTime.fromDate || dateTime.toDate}
              onClick={clearFilters}
            />
          </div>
          <div className="date_Filters ">
            <div
              className="input-date "
              style={{
                display: "flex",
                fonrSize: "14px",
                alignItems: "center",
                cursor: "pointer",
                height: "34px",
                width: "150px",
                zIndex: 9,
                position: "relative",
                background: "#fff",
              }}
              onClick={() =>
                setOpenDatePicker((prev) => ({ ...prev, fromDate: true }))
              }
            >
              <DatePicker
                onClickOutside={() =>
                  setOpenDatePicker((prev) => ({ ...prev, fromDate: false }))
                }
                open={openDatePicker.fromDate}
                placeholderText="From Date"
                maxDate={dateTime?.toDate && new Date(dateTime?.toDate)}
                readOnly
                showMonthDropdown // 🔹 Allows selecting months when clicking on month
                showYearDropdown // 🔹 Allows selecting years when clicking on year
                dropdownMode="select"
                className="input-date-hidden"
                dateFormat="dd/MM/yyyy"
                selected={
                  dateTime.fromDate ? new Date(dateTime.fromDate) : null
                }
                onChange={(date) => {
                  if (date) {
                    let fromDate = new Date(date).setHours(0, 0, 0, 0);
                    fromDate = new Date(fromDate).toISOString();
                    const updatedDateTime = { ...dateTime, fromDate };
                    onFilterChange(filters, updatedDateTime); // Call onFilterChange with updated dateTime
                  }
                }}
              />
              <img
                src={calender}
                style={{ width: "18px", position: "absolute", right: "15px" }}
              />
            </div>
            <div className="text-xl font-thin">-</div>
            <div
              className="input-date  "
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                height: "34px",
                width: "150px",
                position: "relative",
                background: "#fff",
                zIndex: 9,
              }}
              onClick={() => {
                if (dateTime?.fromDate) {
                  setOpenDatePicker((prev) => ({ ...prev, toDate: true }));
                }
              }}
            >
              <DatePicker
                placeholderText="To Date"
                onClickOutside={() =>
                  setOpenDatePicker((prev) => ({ ...prev, toDate: false }))
                }
                open={openDatePicker.toDate}
                disabled={!dateTime.fromDate}
                minDate={dateTime?.fromDate && new Date(dateTime?.fromDate)}
                style={{ zIndex: 1000 }}
                readOnly
                showMonthDropdown // 🔹 Allows selecting months when clicking on month
                showYearDropdown // 🔹 Allows selecting years when clicking on year
                dropdownMode="select"
                className="input-date-hidden "
                dateFormat="dd/MM/yyyy"
                selected={dateTime.toDate ? new Date(dateTime.toDate) : null}
                onChange={(date) => {
                  if (date) {
                    let toDate = new Date(date).setHours(23, 59, 59, 999);
                    toDate = new Date(toDate).toISOString();
                    const updatedDateTime = { ...dateTime, toDate };
                    onFilterChange(filters, updatedDateTime);
                  }
                }}
              />
              <img
                src={calender}
                style={{ width: "18px", position: "absolute", right: "15px" }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="w-full items-center flex gap-8 py-[15px] px-[15px] mt-6 bg-white" style={{ borderTopLeftRadius: "15px", borderTopRightRadius: "15px" }}>
        {onSearch && (
          <div
            style={{ position: "relative", height: "40px", width: "100%" }}
          >
            <img
              src={search}
              alt="search icon"
              style={{ position: "absolute", left: "20px", top: "10px" }}
            />
            <input
              onChange={(e) => onSearch(e.target.value)}
              placeholder="Search request by request no..."
              style={{
                width: "70%",
                height: "100%",
                maxWidth: "450px",
                borderRadius: "4px",
                border: "none",
                boxShadow: "0px 3px 4px rgba(0,0,0,0.2)",
                padding: "10px 10px 10px 60px",
                fontSize: "12px",
                background: "#FAFAFA"
              }}
            />
          </div>
        )}
        {/* <div className="flex gap-2  ">
          {ChipInputOptions &&
            ChipInputOptions.length > 0 &&
            ChipInputOptions.map((chip) => {
              return (
                <ChipInput
                  statusType={statusType}
                  key={chip.id}
                  label={chip.label}
                  onFilterChange={(statusType) => {
                    onStatusFilterChanged(statusType);
                  }}
                />
              );
            })}
        </div> */}
        <div className="">
          <SelectComponent
            controlStyle={{
              height: "40px",
              width: "200px",
              minHeight: "20px",
              border: "none",
              boxShadow: "0px 3px 4px rgba(0,0,0,0.2)",
              background: "#fff",
              color: "hsl(0deg 0% 20% / 64%)",
              fontSize: "10px",
              padding: "0px 3px",
            }}
            isSearchable={true}
            value={
              statusType
                ? { label: statusType, value: ChipInputOptions.find((chip) => chip.label === statusType)?.id }
                : { label: "Scheduled", value: 3 }
            }
            placeholder={"Select Status "}
            menuPlacement={"bottom"}
            list={
              ChipInputOptions.map((chip) => ({
                label: chip.label,
                value: chip.id,
              }))
            }
            onChange={(selectedStatus) => {
              onStatusFilterChanged(selectedStatus.label);
              console.log("selectedStatus", selectedStatus);
            }}
          />
        </div>
        <div className="">
          <SelectComponent
            controlStyle={{
              height: "40px",
              width: "200px",
              minHeight: "20px",
              border: "none",
              boxShadow: "0px 3px 4px rgba(0,0,0,0.2)",
              background: "#fff",
              color: "hsl(0deg 0% 20% / 64%)",
              fontSize: "10px",
              padding: "0px 3px",
            }}
            isSearchable={true}
            value={
              selectedLocation
                ? { label: selectedLocation.name, value: selectedLocation.id }
                : null
            }
            placeholder={"Select Location "}
            menuPlacement={"bottom"}
            list={[
              { label: "All", value: "all" }, // Add "All" option
              ...locations.map((l) => ({
                label: l?.name,
                value: l.id,
              })),
            ]}
            onChange={(location) => {
              let updatedFilters;
              if (location.value === "all") {
                updatedFilters = { ...filters, locations: [] };
              } else {
                updatedFilters = { ...filters, locations: [location.value] };
              }
              onFilterChange(updatedFilters, dateTime);
            }}
          />
        </div>
      </div>
      <TableView
        loadingHeight={"300px"}
        isLoading={loading}
        onStateChange={async (changedState) => {
          const { pageNumber } = changedState;
          onCurrentPageChange(pageNumber);
        }}
        onClickRow={(request) => {
          nevigate(`${ROUTES.REQUESTSOVERVIEW}`, {
            state: {
              request: request,
              filters: {
                ...filters,
                userId: state?.userId,
                pageNumber,
                statusType,
                fromDate: dateTime?.fromDate,
                toDate: dateTime?.toDate
              },
            },
          });
        }}
        columns={[
          { Header: "Request No.", accessor: "req_number" },
          { Header: "Location", accessor: "location_name" },
          { Header: "Brief Address", accessor: "location_address" },
          { Header: "Service", accessor: "serviceType" },
          {
            Header: "Customer Name", accessor: "user_name", Cell: ({ row }) => (
              <div className="flex items-center gap-3">
                <Tippy content={row.original?.user_name}>
                  <span className="w-[90px]">
                    {reduceLongName(row.original?.user_name || "-", 13)}
                  </span>
                </Tippy>
              </div>
            ),
          },
          {
            Header: "Date Received",
            accessor: "date_created",
            isDate: true,
            format: "dd/mm/yyyy",
          },
          {
            Header: "Service Date",
            accessor: "time",
            isDate: true,
            format: "dd/mm/yyyy",
          },
          { Header: "Status", accessor: "status", showColor: true },
        ]}
        count={totalCount}
        pageSize={pageSize}
        pageNumber={pageNumber || undefined}
        data={localRequest?.map((req) => ({
          ...req,
          status: req.status,
          serviceType: req?.type.split(" ")[0],
          color: getStatusColor(req.status, true),
        }))}
        tableContainerHeight={tabelContainerHeight || "500px"}
        hidePagination={hidePagination}
        scrollTableStyle={{ borderBottomLeftRadius: "15px", borderBottomRightRadius: "15px" }}
        paginationItemStyle={{ backgroundColor: "#fff", color: "black" }}
      />
    </>
  );
};

export default RequestTable;
